import { Component, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LPGDistService } from '../../lpg-dist.service';
import { MessageLevel, PgMessagesService } from '../../../shared/services/pg-messages.service';
import { OrganisationService } from 'src/app/organisation/organisation.service';
import { Organisation } from 'src/app/generated/services/organisations/organisation';
import { SharedModule } from 'src/app/shared/shared.module';
import { MaterialOrganisationSelectorComponent } from 'src/app/shared/components/material-autocomplete/material-organisationselector.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MaterialFileUploadComponent } from 'src/app/shared/components/material-file-uploader/material-file-uploader.component';
import { MaterialPgInputComponent } from 'src/app/shared/components/material-pg-input/material-pg-input.component';

@Component({
  selector: 'app-lpg-dist-file-uploader',
  templateUrl: './lpg-dist-file-uploader.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports:[
    SharedModule,
    MaterialOrganisationSelectorComponent,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MaterialFileUploadComponent,
    MaterialPgInputComponent
  ],
})
export class LpgDistFileUploaderComponent implements OnInit {
  title = new EventEmitter<string>();

  company: Organisation = Organisation.create();
  companyForPayment: Organisation = Organisation.create();
  lpgPriceForPayment?: number;
  organisations: Organisation[] = [];
  currentFiles?: FileList;
  currentQuotaFiles?: FileList;
  currentPaymentFiles?: FileList;
  lpgPrice?: number;

  constructor(private _lpgdistservice: LPGDistService,
    private _organisationService: OrganisationService,
    private _pgMessagesService: PgMessagesService) { }

  async ngOnInit(): Promise<void> {
    this.title.emit('Import NIPDC file');
    this._organisationService.get().subscribe(o => {
      this.organisations = o.filter(organisation => organisation.properties['domestic'] === true);
    });
  }

  uploadQuotaDocument() {
    if(this.currentQuotaFiles) {
      this._lpgdistservice.importQuotaFile(this.currentQuotaFiles).subscribe(() => {
        this._pgMessagesService.publishMessage({
          level: MessageLevel.Info,
          topic: 'Quota',
          message: 'Successfully imported file'
        });
      });
    }
  }

  uploadPaymentDocument() {
    if(this.currentPaymentFiles) {
      this._lpgdistservice.importPaymentFile(this.currentPaymentFiles,
        this.companyForPayment.name, String(this.lpgPriceForPayment)).subscribe(() => {
        this._pgMessagesService.publishMessage({
          level: MessageLevel.Info,
          topic: 'Payment',
          message: 'Successfully imported file'
        });
      });
    }
  }

  uploadDocument() {
    if(this.currentFiles) {
      this._lpgdistservice.importLpgDistFile(this.company.name, this.currentFiles, String(this.lpgPrice)).subscribe(() => {
        this._pgMessagesService.publishMessage({
          level: MessageLevel.Info,
          topic: 'NIOPDC',
          message: 'Successfully imported file'
        });
      });
    }
  }
}
